"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TDJSONWriter = void 0;
var TDJSONWriterOption_1 = require("./TDJSONWriterOption");
var TDNode_1 = require("../TDNode");
var StringBuilder_1 = require("../core/StringBuilder");
var StringUtil_1 = require("../core/StringUtil");
var LangUtil_1 = require("../core/LangUtil");
var NON_STRING = TDJSONWriterOption_1.TextType.NON_STRING;
var STRING = TDJSONWriterOption_1.TextType.STRING;
var KEY = TDJSONWriterOption_1.TextType.KEY;
var OPERATOR = TDJSONWriterOption_1.TextType.OPERATOR;
var TDJSONWriter = /** @class */ (function () {
    function TDJSONWriter() {
    }
    TDJSONWriter.get = function () {
        return TDJSONWriter.instance;
    };
    TDJSONWriter.writeAsString = function (node, opt) {
        if (opt === void 0) { opt = {}; }
        return TDJSONWriter.get().writeAsString(node, opt);
    };
    TDJSONWriter.write = function (out, node, opt, indentStr) {
        if (opt === void 0) { opt = {}; }
        if (indentStr === void 0) { indentStr = ''; }
        return TDJSONWriter.get().write(out, node, opt, (indentStr = ''));
    };
    TDJSONWriter.prototype.writeAsString = function (node, opt) {
        if (opt === void 0) { opt = {}; }
        var out = new StringBuilder_1.StringBuilder();
        this.write(out, node, opt);
        return out.toString();
    };
    TDJSONWriter.prototype.write = function (out, node, option, indentStr) {
        if (option === void 0) { option = {}; }
        if (indentStr === void 0) { indentStr = ''; }
        var opt = option instanceof TDJSONWriterOption_1.TDJSONWriterOption ? option : LangUtil_1.LangUtil.mergeDeep(new TDJSONWriterOption_1.TDJSONWriterOption(), option);
        if (!node)
            return out.append(opt.deco("null", NON_STRING));
        var childIndentStr = '';
        if (opt.hasIndent())
            childIndentStr = indentStr + opt.indentStr;
        switch (node.type) {
            case TDNode_1.TDNodeType.MAP:
                return this.writeMap(out, node, opt, indentStr, childIndentStr);
            case TDNode_1.TDNodeType.ARRAY:
                return this.writeArray(out, node, opt, indentStr, childIndentStr);
            default:
                return this.writeSimple(out, node, opt);
        }
    };
    TDJSONWriter.prototype.writeMap = function (out, node, opt, indentStr, childIndentStr) {
        out.append(opt.deco(opt.deliminatorObjectStart.substring(0, 1), OPERATOR));
        if (node.children != null) {
            for (var i = 0; i < node.getChildrenSize(); i++) {
                var cn = opt.applyFilters(node.children[i]);
                if (cn == null)
                    continue;
                if (opt.hasIndent()) {
                    out.append('\n');
                    out.append(childIndentStr);
                }
                if (!StringUtil_1.StringUtil.isJavaIdentifier(cn.key) || opt.alwaysQuoteName)
                    // Quote the key in case  it's not valid java identifier
                    this.writeQuotedString(out, cn.key, opt, KEY);
                else
                    out.append(opt.deco(cn.key, KEY)); // Map key will never be null
                out.append(opt.deco(opt.deliminatorKey, OPERATOR));
                this.write(out, cn, opt, childIndentStr);
                if (i < node.getChildrenSize() - 1)
                    // No need "," for last entry
                    out.append(opt.deco(opt.deliminatorValue, OPERATOR));
            }
            if (opt.hasIndent() && node.hasChildren()) {
                out.append('\n');
                out.append(indentStr);
            }
        }
        return out.append(opt.deco(opt.deliminatorObjectEnd.substring(0, 1), OPERATOR));
    };
    TDJSONWriter.prototype.writeArray = function (out, node, opt, indentStr, childIndentStr) {
        out.append(opt.deco(opt.deliminatorArrayStart.substring(0, 1), OPERATOR));
        if (node.children != null) {
            for (var i = 0; i < node.getChildrenSize(); i++) {
                var cn = node.children[i];
                if (opt.hasIndent()) {
                    out.append('\n');
                    out.append(childIndentStr);
                }
                this.write(out, cn, opt, childIndentStr);
                if (i < node.getChildrenSize() - 1)
                    // No need "," for last entry
                    out.append(opt.deco(opt.deliminatorValue, OPERATOR));
            }
            if (opt.hasIndent() && node.children.length > 0) {
                out.append('\n');
                out.append(indentStr);
            }
        }
        return out.append(opt.deco(opt.deliminatorArrayEnd.substring(0, 1), OPERATOR));
    };
    TDJSONWriter.prototype.writeSimple = function (out, node, opt) {
        var value = node.value;
        if (typeof value === 'string')
            return this.writeQuotedString(out, value, opt, STRING);
        return out.append(opt.deco("" + value, NON_STRING));
    };
    TDJSONWriter.prototype.writeQuotedString = function (out, str, opt, textType) {
        out.append(opt.quoteChar);
        out.append(opt.deco(StringUtil_1.StringUtil.cEscape(str, opt.quoteChar), textType));
        return out.append(opt.quoteChar);
    };
    TDJSONWriter.instance = new TDJSONWriter();
    return TDJSONWriter;
}());
exports.TDJSONWriter = TDJSONWriter;
//# sourceMappingURL=TDJSONWriter.js.map